import { TProcessStates } from "../../../lib/types/general";
import { LabSignUpFormData, TApiLab } from "../../../lib/types/labs";
import { BlacklistButton } from "../../common/blacklist-button";
import { ReportButton } from "../../common/report-button";
import { Events } from "./events";
import { Landmarks } from "./landmarks";
import { Restaurants } from "./restaurants";

type TLifeStyleProps = {
    editable: boolean;
    isSomePartBeingEdited: boolean;
    userInfo: TApiLab;
    workingState: TProcessStates;
    userId: string | undefined;
    setUserInfo: React.Dispatch<React.SetStateAction<TApiLab>>;
    setIsSomePartBeingEdited: (value: React.SetStateAction<boolean>) => void;
    updateLabAndLocalStorage: (data: LabSignUpFormData, name?: string) => Promise<void>;
};

export const LifeStyle = ({
    editable,
    isSomePartBeingEdited,
    userInfo,
    workingState,
    userId,
    setUserInfo,
    setIsSomePartBeingEdited,
    updateLabAndLocalStorage,
}: TLifeStyleProps) => {
    return (
        <div className="row justify-content-center lab-row mt-5 p-4 bg-light rounded ">
            <h4 className="text-start fw-bold mb-3">LIFESTYLE</h4>
            {editable && (
                <p className="text-start text-muted mb-4">
                    Add nearby restaurants, events, and landmarks to help candidates get a feel for the area around your company.
                </p>
            )}
            {!editable && (
                <p className="text-start text-muted mb-4">
                    Explore nearby restaurants, events, and landmarks to get a better feel for the area around this company.
                </p>
            )}
            <Restaurants
                editable={editable}
                isSomePartBeingEdited={isSomePartBeingEdited}
                setIsSomePartBeingEdited={setIsSomePartBeingEdited}
                setUserInfo={setUserInfo}
                updateLabAndLocalStorage={updateLabAndLocalStorage}
                userInfo={userInfo}
                workingState={workingState}
            />
            <Events
                editable={editable}
                isSomePartBeingEdited={isSomePartBeingEdited}
                setIsSomePartBeingEdited={setIsSomePartBeingEdited}
                setUserInfo={setUserInfo}
                updateLabAndLocalStorage={updateLabAndLocalStorage}
                userInfo={userInfo}
                workingState={workingState}
            />
            <Landmarks
                editable={editable}
                isSomePartBeingEdited={isSomePartBeingEdited}
                setIsSomePartBeingEdited={setIsSomePartBeingEdited}
                setUserInfo={setUserInfo}
                updateLabAndLocalStorage={updateLabAndLocalStorage}
                userInfo={userInfo}
                workingState={workingState}
            />

            {!editable && (
                <div className="container">
                    <div className="row justify-content-center justify-content-md-end lab-row mt-5">
                        <div className="w-auto py-3 px-md-5 text-center text-md-end">
                            <BlacklistButton userId={Number(userId)} isInBlacklist={userInfo.is_in_blacklist} />
                            <ReportButton userId={Number(userId)} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
